import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shared/icons/alert-icon.svg'
import _imports_1 from '@/assets/shared/icons/info-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-62f93cc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-box" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["icon-box", { 'alert-icon': _ctx.alert, 'info-icon': _ctx.info }])
    }, [
      (_ctx.alert)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_ctx.info)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["text-box", { 'alert-text-box': _ctx.alert, 'info-text-box': _ctx.info }])
    }, [
      _createElementVNode("div", {
        class: "warning-text",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
        innerHTML: _ctx.stepContent.warningText
      }, null, 8, _hoisted_4)
    ], 2)
  ]))
}